import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { AudioTrack } from '../types';

interface UseAudioTracksReturn {
  tracks: AudioTrack[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useAudioTracks = (): UseAudioTracksReturn => {
  const [tracks, setTracks] = useState<AudioTrack[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTracks = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getAudioTracks();
      setTracks(response.tracks || []);
    } catch (err) {
      console.error('Error fetching audio tracks:', err);
      setError('Error loading audio tracks');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTracks();
  }, []);

  return {
    tracks,
    loading,
    error,
    refetch: fetchTracks,
  };
};
